// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9422":"a7f2d541","9757":"a7f2d541"}[chunkId] + ".chunk.css";
};